import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

import IconSearch from "./search.svg";

type ContainerProps = ResponsiveStyledProps & {
  $showDesktopDivider?: boolean;
};

export const Container = styled.div<ContainerProps>`
  align-items: center;

  ${({ $showDesktopDivider }) =>
    $showDesktopDivider &&
    css`
      ${theme.breakpoints.up("desktop")} {
        position: relative;

        margin-inline-start: 12px;
        padding-inline-start: 24px;

        &::before {
          position: absolute;
          inset-block-start: 50%;
          inset-inline-start: 0;
          content: "";

          inline-size: 1px;
          block-size: 20px;

          background-color: #dfdfdf;

          transform: translateY(-50%);
        }
      }
    `}

  ${responsiveStyles}
`;

export const StyledBaseLink = styled(BaseLink)`
  inline-size: 24px;
  block-size: 24px;
`;

export const StyledIconSearch = styled(IconSearch)`
  inline-size: 100%;
  block-size: 100%;

  path {
    fill: #000000;
  }
`;
